import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import localeText from "../../../../../locale";
import UserInitialsAvatar from "../../../../../components/UserInitialsAvatar/UserInitialsAvatar";

const ExtracreditTransferStep1Recipient = ({
  onRecipientFound,
  onSearch,
  loading,
  error,
  recipient,
}) => {
  const [username, setUsername] = useState("");

  const handleSearch = () => {
    const trimmed = username?.trim();
    if (!trimmed) return;
    onSearch(trimmed);
  };

  if (recipient) {
    return (
      <div className="flex flex-column align-items-center gap-4">
        <div
          className="p-3"
          style={{
            background:
              "linear-gradient(to bottom,rgba(113, 119, 132, 0.25),rgba(113, 119, 132, 0.03))",
            borderRadius: "50%",
          }}
        >
          <div
            className="flex align-items-center justify-content-center overflow-hidden"
            style={{
              width: "96px",
              height: "96px",
              backgroundColor: "#FFFFFF",
              borderRadius: "50%",
            }}
          >
            <UserInitialsAvatar
              avatarUrl={recipient?.urlAvatar}
              firstName={recipient?.firstName}
              lastName={recipient?.lastName}
              fullName={recipient?.name || recipient?.username}
              style={{ width: "100%", height: "100%", fontSize: "2rem" }}
              alt="recipient-avatar"
            />
          </div>
        </div>
        <div className="text-center w-full">
          <h4 className="mb-2 m-0">
            {localeText("recipientSelection") || "Seleção do destinatário"}
          </h4>
          <p className="text-600 mb-4 m-0">
            {localeText("recipientSelectionHint") || "Selecione quem receberá sua transferência."}
          </p>
        </div>
        <div
          className="w-full p-4 border-round-md"
          style={{ border: "1px solid var(--theme-border, #E9ECEF)", maxWidth: "400px" }}
        >
          <div className="text-sm text-600 mb-2">{localeText("recipientDetails")}</div>
          <div className="flex align-items-center justify-content-between flex-wrap gap-2">
            <div>
              <div className="font-semibold" style={{ color: "#171717" }}>
                {recipient.name || recipient.firstName || recipient.username}
              </div>
              <div className="text-sm text-600">{recipient.email}</div>
              {recipient.username && <div className="text-sm text-500">{recipient.username}</div>}
            </div>
          </div>
          <hr className="my-3" style={{ borderColor: "var(--theme-border, #E9ECEF)" }} />
          <div className="flex gap-2">
            <Button
              size="small"
              label={localeText("changeRecipient")}
              className="p-button-outlined flex-1 border-round-md p-no-outline"
              style={{ border: "1px solid var(--theme-border, #EBEBEB)", color: "var(--theme-text-muted, #5C5C5C)" }}
              onClick={() => onRecipientFound(null)}
            />
            <Button
              size="small"
              className="flex-1 border-round-md p-no-outline border-none"
              style={{ backgroundColor: "var(--theme-primary, #1DAF61)", color: "#FFFFFF" }}
              label={localeText("nextAction")}
              onClick={() => onRecipientFound(recipient)}
              disabled={!recipient}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-column align-items-center gap-4">
      <div
        className="p-3"
        style={{
          background:
            "linear-gradient(to bottom,rgba(113, 119, 132, 0.25),rgba(113, 119, 132, 0.03))",
          borderRadius: "50%",
        }}
      >
        <div
          className="flex align-items-center justify-content-center border-round-circle"
          style={{
            width: "96px",
            height: "96px",
            backgroundColor: "#FFFFFF",
            borderRadius: "50%",
            boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
          }}
        >
          <i className="pi pi-user text-5xl" style={{ color: "var(--theme-text-muted, #5C5C5C)" }} />
        </div>
      </div>
      <div className="text-center w-full">
        <h4 className="mb-2 m-0">
          {localeText("recipientSelection") || "Seleção do destinatário"}
        </h4>
        <p className="text-600 mb-4 m-0">
          {localeText("recipientSelectionHint") || "Selecione quem receberá sua transferência."}
        </p>
      </div>
      <div className="w-full" style={{ maxWidth: "400px" }}>
        <label htmlFor="recipient-search" className="block mb-2 font-medium">
          {localeText("chooseRecipient")}
        </label>
        <span className="p-input-icon-left w-full block">
          <i className="pi pi-search" />
          <InputText
            id="recipient-search"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            placeholder={localeText("searchRecipient")}
            className="w-full border-round-lg"
            disabled={loading}
          />
        </span>
        {error && <p className="text-red-500 text-sm mt-2 m-0">{localeText("userNotFound")}</p>}
        <Button
          label={localeText("search") || "Procurar"}
          className="w-full mt-4 border-round-md border-none p-no-outline"
          style={{ backgroundColor: "var(--theme-primary, #1DAF61)", color: "#FFFFFF" }}
          onClick={handleSearch}
          loading={loading}
          disabled={!username?.trim()}
        />
      </div>
    </div>
  );
};

export default ExtracreditTransferStep1Recipient;
